"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var config_1 = __importDefault(require("config"));
var api_1 = __importDefault(require("api"));
var use_stores_1 = require("hooks/use-stores");
var Login_1 = __importDefault(require("components/login/Login"));
var SplashScreen_1 = __importDefault(require("components/SplashScreen"));
var Root_1 = __importDefault(require("./components/Root"));
var use_notification_1 = require("./hooks/use-notification");
var Notification_1 = require("./components/Notification");
var mobx_react_1 = require("mobx-react");
var Routes = mobx_react_1.observer(function () {
    var _a = react_1.useState(false), userCheck = _a[0], setUserCheck = _a[1];
    var _b = react_1.useState(false), exiting = _b[0], setExiting = _b[1];
    var _c = react_1.useState(false), busy = _c[0], setBusy = _c[1];
    var history = react_router_dom_1.useHistory();
    var _d = use_stores_1.useStores(), userStore = _d.userStore, prefsStore = _d.prefsStore, apiStore = _d.apiStore;
    var exitTimeoutRef = react_1.useRef(null);
    var checkTimeoutRef = react_1.useRef(null);
    var busyTimerRef = react_1.useRef(null);
    var notification = use_notification_1.useNotification();
    react_1.useEffect(function () {
        var localUser = localStorage.getItem(config_1.default.storageKeys.USER);
        var localPrefs = localStorage.getItem(config_1.default.storageKeys.PREFS);
        if (localUser === null) {
            history.replace("/login");
            exitToScreen();
        }
        else {
            api_1.default.getSelf()
                .then(function (response) {
                userStore.setData(response.data);
                if (history.location.pathname === "/login") {
                    history.replace("/");
                    return;
                }
                exitToScreen();
            }, function (error) {
                localStorage.removeItem(config_1.default.storageKeys.USER);
                history.replace('/login');
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: 'Couldn\'t find user information. Please try logging in again.'
                });
                exitToScreen();
            });
        }
        if (localPrefs !== null) {
            prefsStore.setData(JSON.parse(localPrefs));
        }
        return function () {
            clearTimeout(exitTimeoutRef.current);
            clearTimeout(checkTimeoutRef.current);
        };
    }, []);
    react_1.useEffect(function () {
        if (apiStore.data.error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: apiStore.data.error
            });
        }
        clearTimeout(busyTimerRef.current);
        if (apiStore.data.busy) {
            busyTimerRef.current = setTimeout(function () {
                setBusy(true);
            }, 1500);
        }
        else {
            setBusy(false);
        }
    }, [apiStore.data]);
    var exitToScreen = function () {
        clearTimeout(exitTimeoutRef.current);
        clearTimeout(checkTimeoutRef.current);
        exitTimeoutRef.current = setTimeout(function () {
            setExiting(true);
            checkTimeoutRef.current = setTimeout(function () {
                setUserCheck(true);
            }, 500);
        }, 1000);
    };
    return userCheck ? (react_1.default.createElement("div", null,
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/login", component: Login_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", component: Root_1.default })))) : react_1.default.createElement(SplashScreen_1.default, { exiting: exiting });
});
exports.default = Routes;
